// extracted by mini-css-extract-plugin
export default {"unordered-list":"wysiwyg_unordered-list__CEqZ1","ordered-list":"wysiwyg_ordered-list__CxqFF"};